const drawerWidth = 380;
const DrawerContainerStyles = (theme) => ({
  shiftedContent: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginRight: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
  },
  transition: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  paperAnchor: {
    position: "absolute",
    padding: 0,
    borderLeft: `1px solid ${theme.AppBGColor}`,
    boxShadow: "none",
    width: 380,
    boxSizing: "border-box",
    backgroundColor: theme.gridBGColor,
    transform: "translate(0px, 0px)",
    transition: theme.transitions.create(["width"], {
      easing: theme.transitions.easing.easeIn,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  paperHidden: {
    height: 0,
    width: 0,
  },
  applyDrawerShadow: {
    boxShadow: `0px 0px 5px ${theme.TextColor}`,
  },
  backdrop: {
    position: "absolute",
    backgroundColor: "transparent",
  },
  nonTransparentBackdrop: {
    position: "absolute",
  },
  modal: {
    position: "absolute",
  },
  gridAction: {
    display: "inline-flex",
  },
  actionContainer: {
    paddingTop: 32,
  },
});

export default DrawerContainerStyles;
